<div class="chat-message"
  [ngClass]="{'user-message': isSender, 'ai-message': !isSender, 'animate-popup': chatMessage.withAnimation}">
  <div class="message-header" [ngClass]="{'sender-header': isSender, 'receiver-header': !isSender}">
    <div class="header-content">
      <div class="user-name">{{ resolveUserName(chatMessage.user.name) }}</div>
      <div class="message-time">{{ chatMessage.timestamp }}</div>
    </div>
    <div class="user-avatar" [ngClass]="{'ai-user': !isSender, 'human-user': isSender}">
      @if(chatMessage.user.avatarUrl) {
        <img [src]="chatMessage.user.avatarUrl" [alt]="resolveUserName(chatMessage.user.name) + ' avatar'">
      }
      @else{
      <i [ngClass]="{'fa-atom': !isSender, 'fa-user-circle': isSender}" class="fal"
      aria-hidden="true"></i>
    }
  </div>
</div>

@if(isSender){
  <div class="message-body sender-body" [innerHTML]="chatMessage.message | safeHtml">
  </div>
}
@else{
@if (!chatMessage.thinkingIndicator) {
  <div class="message-body receiver-body">
    <div [innerHTML]="chatMessage.message | safeHtml"></div>
    @if(chatMessage.hasLiveChatButton && isNiceChatEnabled) {
      <div class="live-chat-button-container button-sleeve">
        <button type="button" class="prominent focus-visibility" (click)="onLaunchLiveChat()">
          <span>{{resourceStrings['Aon.AI.Chat.OpenLiveChat.ButtonText']}}</span>
        </button>
      </div>
    }
  </div>
  @if (showDynamicForm) {
    <app-ai-dynamic-template>
    </app-ai-dynamic-template>
  }
} @else {
  <div class="typing-indicator message-body receiver-body">
    <span>{{resourceStrings['Aon.Ai.Panel.ThinkingIndicator']}} </span>
    <span class="dot" aria-hidden="true"></span>
    <span class="dot" aria-hidden="true"></span>
    <span class="dot" aria-hidden="true"></span>
  </div>
}
}

@if(autoFocus && !chatMessage.hasLiveChatButton) {
  <div class="chat-feedback d-flex">
    <div class="chat-feedback-text" id="feedback-message">{{resourceStrings['Aon.Ai.ChatTileFeedback']}}</div>
    <div class="thumbs-icons" aria-labelledby="feedback-message" role="group">
      <i #thumbsUpBtn class="fa fa-thumbs-up iconBorder focus-visibility"
        [ngClass]="{'thumbsActive-Class': ThumbsUp}" tabindex="0" role="button"
        [attr.aria-pressed]="ThumbsUp" [attr.aria-label]="resourceStrings['Aon.AI.Chat.Like']" (click)="toggleThumbsUp()"
      (keydown.enter)="toggleThumbsUp()" (keydown.space)="toggleThumbsUp(); $event.preventDefault()"></i>

      <i class="fa fa-thumbs-down iconBorder focus-visibility" tabindex="0" role="button"
        [ngClass]="{'thumbsActive-Class': ThumbsDown}" [attr.aria-pressed]="ThumbsDown"
        [attr.aria-label]="resourceStrings['Aon.AI.Chat.Dislike']" (click)="toggleThumbsDown()" (keydown.enter)="toggleThumbsDown()"
      (keydown.space)="toggleThumbsDown(); $event.preventDefault()"></i>
    </div>
  </div>
}


</div>
